import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_3 = { class: "text-4xl font-medium" }

import { ref } from "vue";
import { storeToRefs } from "pinia";

import ParentOnboarding from "@/components/ParentOnboarding.vue";
import ResourceCards from "../resources/ResourceCards.vue";
import ParentChildTable from "../ParentChildTable.vue";
import TitleHeader from "../TitleHeader.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { Resource, Student } from "@/types";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParentDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());
const resources = ref([] as Resource[]);

const role = userHasRole(user.value.roles, ["parent"]) ? "parent" : "brick-club-family";

const students = ref([] as Student[]);
const selectedStudent = ref({} as Student);
const showOnboarding = ref(false);

async function listStudents() {
  students.value = (await api.students.listStudentsByParent(user.value.id)).data.students;

  if (!students.value.length) {
    showOnboarding.value = false;
  }

  students.value.map(student => {
    if (!student.parent_onboarded && student.primary_parent === user.value.id) {
      selectedStudent.value = student;
      showOnboarding.value = true;
    }
  });
}

async function updateStudent(editStudent: any, parents: any, step: number) {
  try {
    await api.students.updateStudentByParent(user.value.id, selectedStudent.value.id, {
      student: editStudent,
      parents,
      step,
    });
  } catch (error) {
    console.log(error);
  }
}

resources.value = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.resources.listResources({
    role: role,
    page: 1,
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.resources;

;(
  ([__temp,__restore] = _withAsyncContext(() => listStudents())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (showOnboarding.value)
    ? (_openBlock(), _createBlock(ParentOnboarding, {
        key: 0,
        student: selectedStudent.value,
        user: _unref(user),
        onUpdate: updateStudent,
        onFinish: _cache[0] || (_cache[0] = ($event: any) => (showOnboarding.value = false))
      }, null, 8, ["student", "user"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(TitleHeader, {
          title: _ctx.$t('welcome-back'),
          class: "mt-6"
        }, null, 8, ["title"]),
        (_unref(role) === 'brick-club-family')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("my-children")), 1),
              _createVNode(ParentChildTable, { students: students.value }, null, 8, ["students"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(ResourceCards, {
          role: _unref(role),
          resources: resources.value.splice(0, 3)
        }, null, 8, ["role", "resources"])
      ]))
}
}

})